import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const WalmartProductListings = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <g clipPath="url(#clip0_1503_14939)">
          <rect
            width="248"
            height="143"
            rx="8"
            fill="#ECFEFF"
          />
          <rect
            x="72.75"
            y="46.75"
            width="94.5"
            height="56.5"
            rx="4.39286"
            fill="white"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M161.188 47L74 100.2C74 100.2 74.6124 101.655 75.7024 102.18C76.7925 102.705 78.2709 103 79.8125 103H161.188C162.729 103 164.208 102.705 165.298 102.18C166.388 101.655 167 100.943 167 100.2V49.8C167 49.0574 166.388 48.3452 165.298 47.8201C164.208 47.295 161.188 47 161.188 47Z"
            fill="#E3E3E3"
          />
          <path
            d="M95.6739 59.9957H129.674"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95.6739 67.71H139.674"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95.6739 75.4243H129.674"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95.6739 83.1386H139.674"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95.6739 90.8529H139.674"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="72.75"
            y="46.75"
            width="94.5"
            height="56.5"
            rx="4.39286"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M50.5961 60.6141L53.0015 63.0195L61.0194 55.0016L58.614 52.5962C57.545 51.5613 56.112 50.9881 54.6241 51.0002C53.1363 51.0123 51.7128 51.6087 50.6607 52.6608C49.6086 53.7129 49.0122 55.1364 49.0001 56.6242C48.988 58.1121 49.5612 59.5451 50.5961 60.6141Z"
            fill="#FF808C"
          />
          <path
            d="M69.7749 79.7928L81 83L77.7928 71.7749L69.7749 79.7928Z"
            fill="#FFBC44"
          />
          <path
            d="M61.0194 55.0048L77.7929 71.7783L69.775 79.7962L53.0015 63.0227L61.0194 55.0048Z"
            fill="#FFEF5E"
          />
          <path
            d="M50.5961 60.6141L53.0015 63.0195L61.0194 55.0016L58.614 52.5962C57.545 51.5613 56.112 50.9881 54.6241 51.0002C53.1363 51.0123 51.7128 51.6087 50.6607 52.6608C49.6086 53.7129 49.0122 55.1364 49.0001 56.6242C48.988 58.1121 49.5612 59.5451 50.5961 60.6141Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M69.7749 79.7928L81 83L77.7928 71.7749L69.7749 79.7928Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M61.0194 55.0048L77.7929 71.7783L69.775 79.7962L53.0015 63.0227L61.0194 55.0048Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="146.75"
            y="27.75"
            width="52.5"
            height="52.5"
            rx="26.25"
            fill="white"
          />
          <rect
            x="146.75"
            y="27.75"
            width="52.5"
            height="52.5"
            rx="26.25"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <circle
            cx="173"
            cy="54"
            r="14"
            fill="#1D7AD9"
          />
          <path
            d="M172.994 44.6667C172.297 44.6667 171.744 45.0642 171.744 45.5467L172.168 50.4294C172.213 50.7235 172.568 50.9509 172.996 50.9509C173.425 50.9509 173.777 50.7212 173.825 50.4294L174.251 45.5467C174.251 45.0642 173.694 44.669 172.996 44.669L172.994 44.6667ZM166.093 48.5728C165.874 48.6022 165.665 48.6859 165.485 48.8165C165.305 48.947 165.159 49.1206 165.06 49.3219C164.71 49.9377 164.771 50.6247 165.179 50.8659L169.544 52.9339C169.817 53.0373 170.187 52.8397 170.401 52.4743C170.627 52.0952 170.6 51.6701 170.374 51.4817L166.432 48.6693C166.329 48.6099 166.212 48.5805 166.093 48.5843V48.5728ZM179.897 48.5728C179.779 48.569 179.662 48.5984 179.559 48.6578L175.616 51.484C175.391 51.6724 175.375 52.0975 175.589 52.4766C175.804 52.8535 176.174 53.0511 176.447 52.9362L180.811 50.8682C181.224 50.627 181.283 49.9491 180.935 49.3242C180.834 49.1234 180.686 48.951 180.505 48.822C180.323 48.693 180.113 48.6114 179.893 48.5843L179.897 48.5728ZM169.708 55.0064C169.653 55.0037 169.597 55.0131 169.546 55.034L165.181 57.1157C164.771 57.3593 164.71 58.0348 165.06 58.6621C165.409 59.2894 166.023 59.5674 166.432 59.3261L170.374 56.5183C170.6 56.3276 170.618 55.9025 170.403 55.5257C170.338 55.3901 170.24 55.2734 170.118 55.1863C169.997 55.0992 169.856 55.0445 169.708 55.0271V55.0064ZM176.284 55.0064C176.137 55.0238 175.996 55.0786 175.874 55.1657C175.753 55.2527 175.655 55.3694 175.589 55.505C175.364 55.8819 175.393 56.3069 175.619 56.4976L179.561 59.3307C179.969 59.5605 180.583 59.2802 180.935 58.6667C181.287 58.0532 181.224 57.3639 180.811 57.1203L176.447 55.0478C176.395 55.0271 176.34 55.0177 176.284 55.0202V55.0064ZM172.994 57.0514C172.568 57.0514 172.213 57.2812 172.168 57.5707L171.744 62.4533C171.744 62.9359 172.299 63.3334 172.996 63.3334C173.694 63.3334 174.251 62.9359 174.251 62.4533L173.825 57.5753C173.777 57.2812 173.425 57.056 172.996 57.056L172.994 57.0514Z"
            fill="#FFC220"
          />
          <path
            d="M170.461 107.234H148.899C148.422 107.234 147.957 107.081 147.572 106.798C147.187 106.515 146.903 106.117 146.761 105.661L144.428 98.1936C144.323 97.8584 144.299 97.5032 144.357 97.1567C144.415 96.8103 144.553 96.4823 144.761 96.1993C144.969 95.9163 145.241 95.6862 145.554 95.5275C145.868 95.3688 146.214 95.286 146.565 95.2858H172.131C172.454 95.2869 172.769 95.182 173.027 94.9871L171.656 107.81C171.52 107.623 171.339 107.472 171.131 107.372C170.922 107.271 170.692 107.224 170.461 107.234Z"
            fill="#C2F3FF"
          />
          <path
            d="M151.725 102.924C151.248 102.923 150.783 102.771 150.399 102.488C150.015 102.206 149.73 101.808 149.588 101.352L147.691 95.2858H146.565C146.214 95.286 145.868 95.3688 145.554 95.5275C145.241 95.6862 144.969 95.9163 144.761 96.1993C144.553 96.4824 144.415 96.8103 144.357 97.1568C144.299 97.5032 144.323 97.8584 144.428 98.1937L146.761 105.661C146.903 106.117 147.187 106.515 147.572 106.798C147.957 107.081 148.422 107.234 148.899 107.234H170.461C170.692 107.224 170.922 107.271 171.131 107.372C171.339 107.473 171.52 107.623 171.656 107.81L172.177 102.924H151.725Z"
            fill="#66E1FF"
          />
          <path
            d="M178.675 89.3118H174.855C174.672 89.3105 174.494 89.3765 174.357 89.4974C174.219 89.6183 174.13 89.7856 174.108 89.9675L173.612 93.976C173.567 94.3374 173.392 94.67 173.119 94.9112C172.846 95.1525 172.495 95.2857 172.131 95.2858H146.565C146.214 95.286 145.868 95.3688 145.554 95.5275C145.241 95.6862 144.969 95.9163 144.761 96.1993C144.553 96.4823 144.415 96.8103 144.357 97.1567C144.299 97.5032 144.323 97.8584 144.428 98.1936L146.761 105.661C146.903 106.117 147.187 106.515 147.572 106.798C147.957 107.081 148.422 107.234 148.899 107.234H170.461C170.857 107.234 171.237 107.391 171.517 107.671C171.797 107.951 171.954 108.331 171.954 108.727C171.954 109.123 171.797 109.503 171.517 109.783C171.237 110.063 170.857 110.221 170.461 110.221H149.552"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M172.703 98.2728L172.043 104.214"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M152.541 117.688C153.135 117.688 153.705 117.452 154.125 117.032C154.545 116.612 154.781 116.042 154.781 115.448C154.781 114.854 154.545 114.284 154.125 113.864C153.705 113.444 153.135 113.208 152.541 113.208C151.946 113.208 151.377 113.444 150.957 113.864C150.536 114.284 150.3 114.854 150.3 115.448C150.3 116.042 150.536 116.612 150.957 117.032C151.377 117.452 151.946 117.688 152.541 117.688Z"
            fill="#D7D7D7"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M168.969 117.688C169.563 117.688 170.133 117.452 170.553 117.032C170.973 116.612 171.209 116.042 171.209 115.448C171.209 114.854 170.973 114.284 170.553 113.864C170.133 113.444 169.563 113.208 168.969 113.208C168.375 113.208 167.805 113.444 167.385 113.864C166.965 114.284 166.729 114.854 166.729 115.448C166.729 116.042 166.965 116.612 167.385 117.032C167.805 117.452 168.375 117.688 168.969 117.688Z"
            fill="#D7D7D7"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1503_14939">
            <rect
              width="248"
              height="143"
              rx="8"
              fill="white"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
